import { GrowthContent } from '@mc/api'

export const QUIZ_ENTRY_IN_STICKY_FOOTER_EXP_FLAG = 'pen-5646_v1'

export type pen5646V1Variants = 'control' | 'variant_1' | 'variant_2'

export const ROTATING_INSTRUCTOR_IMAGES: string[] = [
  'https://static.masterclass.com/pen-5646-1.png',
  'https://static.masterclass.com/pen-5646-2.png',
  'https://static.masterclass.com/pen-5646-3.png',
  'https://static.masterclass.com/pen-5646-4.png',
  'https://static.masterclass.com/pen-5646-5.png',
  'https://static.masterclass.com/pen-5646-6.png',
  'https://static.masterclass.com/pen-5646-7.png',
  'https://static.masterclass.com/pen-5646-8.png',
  'https://static.masterclass.com/pen-5646-9.png',
  'https://static.masterclass.com/pen-5646-10.png',
]

export const QUIZ_ENTRY_MODAL_DISMISSED_KEY = 'quizEntryModalDismissed'
export const QUIZ_ENTRY_MODAL_VIEWED_KEY = 'quizEntryModalViewed'

export interface QuizEntryModalTile {
  slug: string
  columnIndex: number
  course?: GrowthContent
}

export const QUIZ_ENTRY_MODAL_TILES: QuizEntryModalTile[] = [
  { slug: 'martin-scorsese-teaches-filmmaking', columnIndex: 0 },
  { slug: 'helen-mirren-teaches-acting', columnIndex: 1 },
  { slug: 'issa-rae-teaches-creating-outside-the-lines', columnIndex: 2 },
  {
    slug: 'gordon-ramsay-teaches-cooking-restaurant-recipes-at-home',
    columnIndex: 1,
  },
  { slug: 'using-humor-to-make-your-mark', columnIndex: 0 },
  { slug: 'alicia-keys-teaches-songwriting-and-producing', columnIndex: 1 },
  {
    slug: 'stephen-curry-teaches-shooting-ball-handling-and-scoring',
    columnIndex: 2,
  },
]
